import React, { useState, useEffect } from "react";
import karimenorriscircle from "./images/karimenorriscircle.png";
import background from "./images/background.png";
import { useNavigate } from "react-router-dom";
import tiktokFilter from "./images/tiktok-filter.png";
import BannerCarousel from "./trending/BannerCarousel";

const QuoteTopImage = () => (
  <div className="mb-3">
    <img alt="Karime Pindter" src={karimenorriscircle} className="h-64" />
  </div>
);

const isInStandaloneMode = () =>
  window.matchMedia("(display-mode: standalone)").matches ||
  window.navigator.standalone === true;

const Home = () => {
  const navigate = useNavigate();
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const [activeItems, setActiveItems] = useState([]);

  useEffect(() => {
    fetch("/data/trending.json")
      .then((res) => res.json())
      .then((data) => {
        const now = new Date();
        const active = data.filter((item) => {
          const start = new Date(item.startTime);
          const end = new Date(item.endTime);
          return now >= start && now <= end;
        });
        setActiveItems(active);
      })
      .catch(() => {});
  }, []);

  return (
    <div
      className="p-5 flex flex-col bg-custom-gray bg-cover bg-center bg-no-repeat h-full relative"
      style={{ backgroundImage: `url(${background})` }}
    >
      <style>{`
        @keyframes trendGlow {
          0%, 100% { box-shadow: 0 4px 16px rgba(249,115,22,0.35); }
          50%       { box-shadow: 0 4px 28px rgba(249,115,22,0.75), 0 0 40px rgba(239,68,68,0.3); }
        }
        .trend-glow {
          animation: trendGlow 2.5s ease-in-out infinite;
        }
        .social-scroll::-webkit-scrollbar { display: none; }
      `}</style>

      <div className="flex-1 flex items-center justify-center flex-col">
        <a
          href="https://www.tiktok.com/t/ZT9eR8LeHnYYP-H7Qf1/"
          target="_blank"
          rel="noopener noreferrer"
          className="absolute top-3 right-3 z-[5] flex items-center gap-1 hover:scale-105 active:scale-95 transition-transform animate-softPulse"
          aria-label="Try TikTok Filter"
        >
          <img src={tiktokFilter} alt="TikTok Filter" className="w-20" />
        </a>

        <QuoteTopImage />

        {/* Trending / voting banner (carrusel si hay más de uno) */}
        <BannerCarousel
          items={activeItems}
          onSelect={(tab) => navigate(`/tendencia?tab=${tab}`)}
        />

        <div className="flex flex-col items-center text-center mb-6 gap-5 w-full md:w-4/5 lg:w-3/5 font-quicksand">
          <button
            className="py-3 px-6 rounded-full w-full text-lg font-bold active:scale-95 transition-transform shadow-md"
            style={{
              background: "#7BDCFB",
              border: "2px solid #38bdf8",
              color: "white",
            }}
            onClick={() => navigate("/select-game")}
          >
            A jugar, bb
          </button>

          <button
            className="py-3 px-6 rounded-full w-full font-bold text-lg active:scale-95 transition-transform shadow-md"
            style={{
              background: "#7BDCFB",
              border: "2px solid #a78bfa",
              color: "white",
            }}
            onClick={() => navigate("/quotes")}
          >
            Frases Icónicas 101
          </button>

          <button
            className="py-3 px-6 rounded-full w-full font-bold text-lg active:scale-95 transition-transform shadow-md"
            style={{
              background: "#7BDCFB",
              border: "2px solid #f472b6",
              color: "white",
            }}
            onClick={() => navigate("/contenido")}
          >
            Kari TV
          </button>
        </div>

        {/* Social links */}
        <div className="flex flex-col items-center gap-2 my-3 w-full">
          <span className="text-base font-semibold font-quicksand">
            Síguela en sus redes:
          </span>
          <div
            className="social-scroll flex gap-2 overflow-x-auto w-full px-5"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {[
              {
                href: "https://www.instagram.com/karimepindter",
                icon: "/icons/instagram.svg",
                alt: "Instagram",
                label: "Instagram",
                invert: true,
                iosScheme: "instagram://user?username=karimepindter",
              },
              {
                href: "https://www.tiktok.com/@karimepindter",
                icon: "/icons/tiktok.svg",
                alt: "TikTok",
                label: "TikTok",
                invert: true,
              },
              {
                href: "https://x.com/realkarime",
                icon: "/icons/x.svg",
                alt: "X",
                label: "Twitter / X",
                invert: true,
              },
              {
                href: "https://www.youtube.com/@KarimePindter",
                icon: "/icons/youtube.svg",
                alt: "YouTube",
                label: "YouTube",
                invert: true,
                iosScheme: "youtube://www.youtube.com/@KarimePindter",
              },
              {
                href: "https://open.spotify.com/artist/5tD4Qq3d2M8TfqUrLlpw4c",
                icon: "/icons/spotify.svg",
                alt: "Spotify",
                label: "Spotify",
                invert: true,
                iosScheme: "spotify://artist/5tD4Qq3d2M8TfqUrLlpw4c",
              },
              {
                href: "https://music.apple.com/us/artist/karime-pindter/1101301790",
                icon: "/icons/apple-music.png",
                alt: "Apple Music",
                label: "Apple Music",
                invert: false,
                iosScheme:
                  "music://music.apple.com/us/artist/karime-pindter/1101301790",
              },
              {
                href: "https://kick.com/realkarime",
                icon: "/icons/kick_png.png",
                alt: "Kick",
                label: "Kick",
                invert: false,
                iconStyle: { filter: "brightness(0) invert(1)" },
                iosScheme: "kick://channel/realkarime",
              },
            ].map(
              ({ href, icon, alt, label, invert, iconStyle, iosScheme }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-shrink-0 flex items-center gap-2 bg-black/10 rounded-full pl-1 pr-3 py-1 hover:bg-black/20 active:scale-95 transition-all"
                  onClick={(e) => {
                    if (iosScheme && isIOS && isInStandaloneMode()) {
                      e.preventDefault();
                      window.location.href = iosScheme;
                      setTimeout(() => window.open(href, "_blank"), 600);
                    }
                  }}
                >
                  <div className="bg-black rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <img
                      src={icon}
                      alt={alt}
                      className={`w-4 h-4 ${invert ? "invert" : ""}`}
                      style={iconStyle}
                    />
                  </div>
                  <span className="text-sm font-semibold font-quicksand whitespace-nowrap text-gray-700">
                    {label}
                  </span>
                </a>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
